import React, { useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './js/Pages/LoginPage';
import Dashboard from './js/Pages/Dashboard';
import AuthContext from './js/Contexts/AuthContext';
import authAPI from './js/Services/authAPI';
import PrivateRoute from './js/Components/PrivateRoute';

authAPI.setup();

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    authAPI.isAuthenticated()
  );
  const [role, setRole] = useState(authAPI.getRole());
  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        role,
        setRole,
        firstname,
        setFirstname,
        lastname,
        setLastname
      }}
    >
      <HashRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
        </Routes>
      </HashRouter>
    </AuthContext.Provider>
  );
}

export default App;
